import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const FilterIconButton = styled.button<{ $isActive?: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: ${RADII.field};
  background: ${({ $isActive }) => ($isActive ? COLORS.fill : 'transparent')};
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${COLORS.fill};
  }

  svg {
    width: 20px;
    height: 20px;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      svg rect,
      svg path {
        fill: ${COLORS.primary};
      }
      svg circle {
        stroke: ${COLORS.primary};
      }
    `}
`

export const ActiveDot = styled.span`
  position: absolute;
  top: 3px;
  right: 3px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${COLORS.primary};
  border: 1.5px solid ${COLORS.surface};
`
